module.exports = "/_next/static/images/eb38622260a0ae862b8618787f698653-aboutus-ed-desktop.jpg.webp";